import { useApi } from '../services';

export const useLogin = (username, password, application, action) => useApi(`/login/v2`, 'POST', {}, { username, password, application, action });

export const useForgotPassword = (username, action) => useApi(`/login/v2`, 'POST', {}, { username, action });

export const useChangePassword = (username, password, action, newPassword,) => useApi(`/login/v2`, 'POST', {}, { username, password, action, newPassword });

export const useGetAllUsers = (idPerson) => useApi(`/v2/user/${idPerson}`, 'GET', {}, {}, true);

export const useExpireUser = (idUser) => useApi(`/v2/user/${idUser}`, 'DELETE', {}, {});

export const useGetUserByPerson = (idPerson) => useApi(`/v2/user/person/${idPerson}`, 'GET', {}, {}, true);

export const useGetUserByName = () => useApi(`/v2/user/userName`, 'POST', {}, {}, true);
